export default __webpack_public_path__ + "static/Geologica-Black-88c064cd8b82dcd9d49fc8ee5d37e2f5.woff2";